export default __webpack_public_path__ + "img/Poppins-Light_3bd71aa.eot";